import { debounce } from "lodash";

let lastInnerHeight = window.innerHeight;

document.documentElement!.style.setProperty(
  "--vh",
  `${lastInnerHeight / 100}px`
);

window.addEventListener(
  "resize",
  debounce(() => {
    if (window.innerHeight !== lastInnerHeight) {
      lastInnerHeight = window.innerHeight;
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight / 100}px`
      );
    }
  }, 500)
);
